import React from 'react'
import SingleQuestion from './SingleQuestion'
import styled from '@mui/material/styles/styled'

export default function Questions({audience, questions}) {
  const GreenScroller = styled('div')({
    maxHeight: '500px',
    overflowY: 'auto',
    scrollbarWidth: 'auto',
    scrollbarColor: '#007A7A #ffffff',    
  })

  return (
    <GreenScroller>
      {questions.map((q, i) => (
        <SingleQuestion qNo={i + 1} audience={audience.value} question={q} />
      ))}
    </GreenScroller>
  )
}
